import { render, staticRenderFns } from "./DashBoardMiddleChart.vue?vue&type=template&id=b5763e04"
import script from "./DashBoardMiddleChart.vue?vue&type=script&lang=js"
export * from "./DashBoardMiddleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports